export default function (createStore, storage) {
    storage = storage || localStorage;
    return function (defaultState, config) {
        var errorHandler;
        var get = function (value) {
            try {
                var item = storage.getItem(config.key);
                return item === null
                    ? value
                    : JSON.parse(item);
            }
            catch (err) {
                errorHandler && errorHandler(err);
            }
            return value;
        };
        var set = function (value) {
            try {
                storage.setItem(config.key, JSON.stringify(value));
            }
            catch (err) {
                errorHandler && errorHandler(err);
            }
        };
        var store = createStore(get(defaultState), config);
        store.defaultState = defaultState;
        store.get = get;
        store.catch = function (handler) {
            errorHandler = handler;
            return store;
        };
        store.watch(set);
        return store;
    };
};
